require('../../modules/es.object.get-own-property-descriptor');
var path = require('../../internals/path');

var Object = path.Object;

var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
  return Object.getOwnPropertyDescriptor(it, key);
};

if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/get-own-property-descriptor.js
// module id = 528
// module chunks = 0 1